import useContextWithErrorHandler from '@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { ResourceFiltersContext } from '../providers/ResourcesProvider';
import { UseResourceFilters } from '../providers/ResourcesProvider/types';

const useResourceFilter = (): UseResourceFilters => {
  const [
    state,
    {
      setResourceFilters,
      setResources,
      removeResource,
      setResourcesSearchText,
      removeAllResourceFilters,
      setSelectedFilters,
      setPinnedResources,
      addPinnedResource,
      removePinnedResource,
      setPinActions,
    },
  ] = useContextWithErrorHandler<UseResourceFilters>(
    ResourceFiltersContext,
    'ResourceFilterProvider'
  );

  return [
    state,
    {
      setResourceFilters,
      setResources,
      removeResource,
      setResourcesSearchText,
      removeAllResourceFilters,
      setSelectedFilters,
      setPinnedResources,
      addPinnedResource,
      removePinnedResource,
      setPinActions,
    },
  ];
};

export default useResourceFilter;
